/**
 * @typedef {Object} NavLink
 * @property {string} label - display text
 * @property {string} href - destination URL or in-page anchor
 */

/**
 * Marketing nav links. Targets are absolute and `/home`-prefixed (the public
 * site's basename) so they resolve under the page's `<base href="/">`.
 *
 * @type {NavLink[]}
 */
export const navLinks = [
  { label: "Features", href: "/home#features" },
  { label: "Sweepstakes", href: "/home/sweepstakes" },
  { label: "Network", href: "/home/network" },
  { label: "Pricing", href: "/home/pricing" },
  { label: "Resources", href: "/home/resources/all" },
];
